import { getClientes, createCliente, updateCliente, deleteCliente, getClienteAtributos } from '../models/clienteModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";
import { get } from 'svelte/store';

export async function fetchClientes(page, perPage) {
  try {
    const response = await getClientes(page, perPage);
    return {
      cliente: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching clientes:", error);
    Swal.fire('Error', 'No se pudieron cargar los clientes', 'error');
    return null;
  }
}

export async function saveCliente(cliente, currentClienteId) {
  try {
    let clienteId;

    if (currentClienteId) {
      // Actualiza el cliente existente
      await updateCliente(currentClienteId, cliente);
      clienteId = currentClienteId;

      toasts.add({
        title: 'Éxito',
        description: 'Cliente guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      // Crea un nuevo cliente y obtiene el ID
      const newCliente = await createCliente(cliente);
      clienteId = newCliente.id;

      toasts.add({
        title: 'Éxito',
        description: 'Cliente creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }

    // Llamar a saveAtributosCliente después de guardar el cliente
    if (cliente['atributos'] && cliente['atributos'].length > 0) {
      console.log('cliente:', cliente);
      await saveAtributosCliente(clienteId, cliente['atributos']);
    }
  } catch (error) {
    console.error("Error saving cliente:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el cliente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeCliente(id) {
  try {
    await deleteCliente(id);
    toasts.add({
      title: 'Éxito',
      description: 'Cliente eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting cliente:", error);
    Swal.fire('Error', 'No se pudo eliminar el cliente', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'cliente'
export function subscribeToClientes(searchQuery, handleSearch) {
  pb.collection('cliente').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromClientes() {
  pb.collection('cliente').unsubscribe('*');
}

export async function searchClientes(query, page = 1, perPage = 10) {
  const response = await pb.collection('cliente').getList(page, perPage, {
    filter: `nombre ~ "${query}"`,
  });
  return {
    cliente: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}

export async function fetchAtributosCliente(id) {
  try {
    const response = await getClienteAtributos(id);
    return {
      atributos: response,
    };
  } catch (error) {
    console.error("Error fetching clientes:", error);
    Swal.fire('Error', 'No se pudieron cargar los clientes', 'error');
    return null;
  }
}

export async function saveAtributosCliente(clienteId, atributos) {
  // Elimina los atributos existentes antes de guardar los nuevos
  await deleteAtributosCliente(clienteId);
  
  try {
    // Itera sobre cada atributo y guarda/actualiza en la colección 'atributo_cliente'
    for (const { atributo, valor } of atributos) {
      await pb.collection('atributo_cliente').create({
        cliente: clienteId,
        atributo: atributo.id,
        valor,
      });
    }

    toasts.add({
      title: 'Éxito',
      description: 'Atributos actualizados exitosamente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error('Error guardando atributos:', error);
    toasts.add({
      title: 'Error',
      description: 'No se pudieron guardar los atributos',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function deleteAtributosCliente(clienteId) {
  try {
    // Recupera los atributos del cliente
    const response = await pb.collection('atributo_cliente').getList(1, 50, {
      filter: `cliente="${clienteId}"`,
    });

    // Elimina cada atributo individualmente
    const deletePromises = response.items.map((item) =>
      pb.collection('atributo_cliente').delete(item.id)
    );

    await Promise.all(deletePromises);
    console.log('Atributos eliminados correctamente');
  } catch (error) {
    console.error('Error eliminando atributos del cliente:', error);
    throw new Error('No se pudieron eliminar los atributos');
  }
}